export default __webpack_public_path__ + "static/media/Leaderboard.2e4d51f0.png";